import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { FrameReturnsService } from '@app/core/services/frame-returns.service';
import { State, Store } from '@ngrx/store';
import { AppState, FrameReturnsActionTypes } from '@app/core/ngrx';
import { NotificationService } from '@app/core/services';

@Component({
  selector: 'ecp-returns-cart',
  templateUrl: './returns-cart.component.html',
  styleUrls: ['./returns-cart.component.scss'],
})
export class ReturnsCartComponent implements OnInit, AfterViewInit {
  @ViewChild('stickyMenu') menuElement: ElementRef;
  return;
  isLoading: boolean;
  sticky = false;
  elementPosition: any;
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private frameReturnsService: FrameReturnsService,
    private state: State<AppState>,
    private store: Store<AppState>,
    private notificationService: NotificationService,
  ) {}

  ngOnInit() {
    if (!this.form) {
      this.form = this.createForm();
    }
  }

  get comments(): AbstractControl {
    return this.form.get('comments');
  }

  get returnRequestId(): AbstractControl {
    return this.form.get('returnRequestId');
  }

  createForm(): FormGroup {
    return this.fb.group({
      returnRequestId: this.getUniqueId(),
      comments: [''],
    });
  }

  getUniqueId() {
    let now = new Date();

    let timestamp = now.getFullYear().toString(); // 2011
    timestamp +=
      (now.getMonth() < 9 ? '0' : '') + (now.getMonth() + 1).toString(); // JS months are 0-based, so +1 and pad with 0's
    timestamp += (now.getDate() < 10 ? '0' : '') + now.getDate().toString(); // pad with a 0
    timestamp += (now.getHours() < 10 ? '0' : '') + now.getHours().toString();
    timestamp +=
      (now.getMinutes() < 10 ? '0' : '') + now.getMinutes().toString();
    timestamp +=
      (now.getSeconds() < 10 ? '0' : '') + now.getSeconds().toString();
    timestamp +=
      (now.getMilliseconds() < 10 ? '0' : '') +
      now.getMilliseconds().toString();
    return timestamp;
  }

  onSubmit() {
    this.isLoading = true;
    let value = this.form.value;
    let stateValue = this.state.getValue();
    value.returnFrames = stateValue.frameReturns.frameReturns; // .framesCart.map(frame => frame.fpc);
    this.frameReturnsService.submitFrameReturns(value).subscribe(
      (resp: any) => {
        this.store.dispatch({
          type: FrameReturnsActionTypes.CLEAR_FRAME_RETURNS,
        });
        this.isLoading = false;
        let notificationOptions = {
          title: 'Success',
          contentHtml: 'Successfully submitted "Return Request" ',
          confirmBtnText: 'Close',
        };
        this.notificationService.error(notificationOptions);
      },
      err => (this.isLoading = false),
      () => {
        // TODO - Add a success submitted cart popup dialog
      },
    );
  }

  ngAfterViewInit() {
    this.elementPosition = this.menuElement.nativeElement.offsetTop;
  }

  @HostListener('window:scroll', ['$event'])
  handleScroll() {
    const windowScroll = window.pageYOffset;
    this.sticky = windowScroll >= this.elementPosition;
  }

  private noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }
}
